import { createFileRoute } from "@tanstack/react-router"

import { IndexToolbar } from "@/components/common/index-toolbar"
import { PageHeader } from "@/components/common/page-header"
import { EmailLogFilters } from "@/features/emails/components/email-log-filters"
import { EmailLogTable } from "@/features/emails/components/email-log-table"
import { emailLogSearchSchema } from "@/features/emails/email-log-search"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/emails/"
)({
  validateSearch: emailLogSearchSchema,
  component: OrganisationEmailsPage,
})

function OrganisationEmailsPage() {
  const filters = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Emails" />
      <section className="flex flex-col gap-4">
        <IndexToolbar>
          <EmailLogFilters
            filters={filters}
            onChange={(search) => {
              void navigate({ replace: true, search })
            }}
          />
        </IndexToolbar>
        <EmailLogTable filters={filters} />
      </section>
    </>
  )
}
